import React from 'react';
import Page from './Page';

const TermsPage = () => (
  <Page
    eyebrow="LEGAL"
    title="Terms of Use"
    subtitle="Effective date: April 2026"
  >
    <p>
      Please read these Terms of Use ("Terms") carefully before using the
      iCraftz™ platform (the "Service"). By accessing or using the Service,
      you agree to be bound by these Terms.
    </p>

    <h2>1. Platform Usage Rules</h2>
    <p>You agree to use iCraftz only for lawful, personal, educational use. You will not:</p>
    <ul>
      <li>Use the Service to violate any law or third-party rights.</li>
      <li>Reverse-engineer, scrape, or systematically copy our content.</li>
      <li>Upload malicious code, attempt to breach security, or disrupt the Service.</li>
      <li>Misrepresent yourself or impersonate any person or organisation.</li>
    </ul>

    <h2>2. Intellectual Property</h2>
    <p>
      All summaries, key insights, action items, infographics, audio podcasts,
      videos, translations, code, design and brand elements published on iCraftz
      are <strong>original works</strong> created by iCraftz and are protected
      by copyright and other intellectual-property laws of India and
      international treaties.
    </p>
    <p>
      Book titles and author names are the property of their respective owners
      and are referenced under the doctrine of fair use for educational and
      review purposes. iCraftz is not affiliated with or endorsed by any
      author or publisher unless expressly stated.
    </p>

    <h2>3. AI-Generated Content Disclaimer</h2>
    <p>
      Portions of the Service are produced or assisted by artificial
      intelligence, including summaries, translations, audio narration and
      video imagery. While we curate carefully, AI output may contain errors
      or simplifications. iCraftz content is intended as an{' '}
      <strong>educational interpretation</strong>, not a substitute for the
      original work. Where direct quotes appear, they are attributed to their
      respective authors.
    </p>

    <h2>4. No Reproduction Without Permission</h2>
    <p>
      You may not reproduce, redistribute, publish, broadcast or commercially
      exploit any iCraftz content (in whole or in part) without our prior
      written permission. Personal, non-commercial sharing of single insight
      cards or video previews on social media — with credit to iCraftz — is
      permitted.
    </p>

    <h2>5. User Submissions</h2>
    <p>
      If you submit suggestions, feedback or contact messages, you grant
      iCraftz a perpetual, royalty-free, worldwide licence to use them for
      improving the Service. You confirm that submissions do not infringe any
      third-party rights.
    </p>

    <h2>6. Limitation of Liability</h2>
    <p>
      The Service is provided "as is" and "as available" without warranties of
      any kind. To the maximum extent permitted by law, iCraftz, its founders
      and partners shall not be liable for any indirect, incidental, special
      or consequential damages arising from your use of, or inability to use,
      the Service. Our total aggregate liability shall not exceed INR 1,000
      or the amount you paid us in the prior 12 months, whichever is greater.
    </p>

    <h2>7. Third-Party Links</h2>
    <p>
      iCraftz may contain links to external sites (such as book purchase
      pages). We are not responsible for the content, accuracy or practices
      of those external sites.
    </p>

    <h2>8. Termination</h2>
    <p>
      We may suspend or terminate your access to the Service at any time,
      with or without notice, if you violate these Terms or engage in conduct
      we determine, in our sole discretion, to be harmful to other users or
      to iCraftz.
    </p>

    <h2>9. Privacy</h2>
    <p>
      Your use of the Service is also governed by our{' '}
      <a href="/privacy">Privacy Policy</a>. By using iCraftz, you consent to
      the practices described there.
    </p>

    <h2>10. Governing Law & Jurisdiction</h2>
    <p>
      These Terms are governed by the laws of India. Any dispute arising out
      of or in connection with these Terms shall be subject to the exclusive
      jurisdiction of the courts at <strong>Bengaluru, Karnataka</strong>.
    </p>

    <h2>11. Changes to Terms</h2>
    <p>
      We may update these Terms periodically. Continued use of the Service
      after changes are posted constitutes acceptance of the revised Terms.
      The latest version will always be at{' '}
      <a href="/terms">icraftz.com/terms</a>.
    </p>

    <h2>12. Contact</h2>
    <p>
      For any question about these Terms, write to us at{' '}
      <a href="mailto:hello@icraftz.com">hello@icraftz.com</a>.
    </p>
  </Page>
);

export default TermsPage;
